<template>
<div class="lh-footer">
    <div class="menu left" :class="menuShow">
        <em @click="openMenu($event)"><i class="iconfont icon-menu"></i><span class="title">菜单</span></em>
        <div class="menu-layer">
            <h3 class="title">目录<i class="iconfont icon-l-close" @click="closeMenu($event)"></i></h3>
            <dl>
                <dt v-for="item in type[footerData.type].directory" :data-path="item.path" @click="goPage($event)">{{item.name}}</dt>
                <!-- <dd>起源与历史</dd>
                <dd>独特性</dd> -->
            </dl>
        </div>
    </div>
	<div class="home left"><router-link to="/" replace><i class="iconfont icon-shouye"></i>首页</router-link></div>
    <div class="course">
        <span class="left title">课程进度</span>
        <div class="course-progress left">
            <div class="hd" :style="{width:''+progress+'%'}"></div>
            <em v-if="progress>0">{{progress}}%</em>
        </div>
        <div class="pages clearfix left">第{{footerData.page}}/{{type[footerData.type].pages}}页</div>
    </div>
    <div class="lh-music left clearfix">
    	<div class="btn left" @click="play($event)"><i class="iconfont" :class="[footerData.audioData.icon]"></i></div>
        <div class="current left">{{footerData.audioData.current}}</div>
        <div class="progress left">
        	<div class="hd" :style="{width:''+footerData.audioData.percentage+'%'}"></div>
        </div>
        <div class="total left">{{footerData.audioData.total}}</div>
    </div>
    <div class="lh-text left">
        <div class="text" :class="textLayerOn" @click="opentextLayer($event)">音频文字</div>
        <div class="lh-text-layer" v-if="footerData.audioData.text">
            {{footerData.audioData.text}}
        </div>
    </div>
    <div class="lh-share left">
        <input name="text" type="text" />
        <i class="iconfont icon-fasong"></i>
    </div>
    <!-- <div class="lh-btn clearfix left">
        <span :data-page="footerData.page" :data-type="footerData.type" @click="routerback($event)"><i class="iconfont icon-l-xiangzuo"></i>返回</span>
        <span>下一页<i class="iconfont icon-l-xiangyou"></i></span>
    </div> -->
    <audio id="audio" src=""></audio>
</div>
</template>
<script>
//import {mapState} from 'vuex'
export default {
    inject: ['reload'],
    data(){
        return {
            menuShow:'',
            textLayerOn:'',
            updateOpen:true,
            type:{
                culture:{//酒文化
                    pages:11,
                    directory:[
                        {name:'酒文化',path:'culture'},
                        {name:'起源与历史',path:'hostory'},
                        {name:'独特性',path:'uniqueness'}
                    ],
                    routers:[
                        {name:'首页',path:'/home',page:''},
                        {name:'酒文化',path:'/culture',page:''},
                        {name:'起源与历史',path:'/hostory',page:1},
                        {name:'先秦',path:'/xianqing',page:2},
                        {name:'汉代',path:'/handai',page:3},
                        {name:'唐代',path:'/tangdai',page:4},
                        {name:'宋代',path:'/songdai',page:5},
                        {name:'明代',path:'/mingdai',page:6},
                        {name:'清代',path:'/qingdai',page:7}
                    ]
                }
            }
        }
    },
    computed:{
        //...mapState(['footerData','name'])
    },
    created(e){
        var that=this;
        var page=that.footerData.page,typeName=that.footerData.type,pages=that.type[typeName].pages;
        //课程进度
        that.progressCal(page,pages);
        that.getBarrage();
    },
    updated(e){
        var that=this,aa=that.updateOpen;
        var page=that.footerData.page,typeName=that.footerData.type,pages=that.type[typeName].pages;
        //课程进度
        that.progressCal(page,pages);
        if(aa){
            that.updateProgress();
            that.updateOpen=false;
        }
    },
    watch:{
        footerData(val){
            console.log('========================')
            if(this.footerData.progress){
                this.progress=100;
                this.updateOpen=false;
                this.updateProgress();
            }
        }
    },
    props:{
        footerData:{
            type:Object
        }
    },
    methods:{
        opentextLayer(e){
            if(this.footerData.audioData.text){
                if(this.textLayerOn){
                    this.textLayerOn="";
                    $('.lh-text-layer').hide();
                }else{
                    this.textLayerOn="on";
                    $('.lh-text-layer').show();
                }
            }
        },
        play(e){
            var that=this;
            var audio = $('#audio')[0];
            if($('#audio').attr('src')){
                if(audio.paused){
                    audio.play();
                    that.footerData.audioData.icon="icon-zanting";   
                }else{
                    audio.pause();
                    that.footerData.audioData.icon="icon-bofang";    
                }
            }
        },
        goPage(e){
            var that=this,path = $(e.currentTarget).data('path');
            window.location.replace('#/'+path);
            this.reload();
        },
        openMenu(e){
            var that=this;
            that.menuShow='on';
        },
        closeMenu(e){
            var that=this;
            that.menuShow='';
        },
        //返回路由
        routerback(e){
            var that=this,page = that.footerData.page,type = that.footerData.type;
            if(page){
                var routers=that.type[type].routers;
                console.log(routers);
                for(var i=0;i<routers.length;i++){
                    if(routers[i].page===page){
                        console.log(routers[i-1].path);
                        if(routers[i-1]){
                            that.$router.replace({ path: routers[i-1].path});
                            //that.$router.go(0);
                        }
                    }
                }
            }else{
               this.$router.back(-1); 
            }
            //console.log(this.$route.name);
            //this.$router.back(-1);
        },
        //课程进度计算
        progressCal(page,pages){
            if(page>0){
                page=page-1;
            }
            var that=this, progress=(Number(page)/Number(pages)*100).toFixed(0);
            that.progress=progress;
        }, 
        //更新课件进度
        updateProgress(e){
          var that=this, uuid=localStorage.getItem("uuid"),userid=localStorage.getItem("userid"),address=localStorage.getItem("address")+'?uuid='+uuid+'&userid='+userid;
          var url='http://zhishi.wuliangye.com.cn:8866/wlyApp/updateH5Progres.html';
          var progres=that.progress;
          var data={userid:userid,uuid:uuid,address:address,progres:progres,chapter:progres}
          if(userid&&uuid){ 
              $.ajax({
                type:'POST',
                url:url,
                data:data,
                dataType:'json',
                success: function(res){
                    console.log(res);
                }
            }); 
          } 
        },
        //发送弹幕
        sendBarrage(e){
            var that=this, cont =this.$refs.cont.value,uuid=localStorage.getItem("uuid"),userid=localStorage.getItem("userid");
            var section=that.footerData.page;
            if(cont){
                var url='http://zhishi.wuliangye.com.cn:8866/wlyApp/saveAskanswer.html';
                var data={userid:userid,uuid:uuid,content:cont,sec:'3000',section:section}
                $.ajax({
                    type:'POST',
                    url:url,
                    data:data,
                    dataType:'json',
                    success: function(res){
                        console.log(res);
                        if(res.res===1){
                            alert('发送弹幕成功,正在审核~');
                        }   
                    }
                }); 
                // axios.post(url,data).then(function(res){
                //     console.log(res);
                // }).catch(function(error){
                //     console.log(error);
                // });
            }
        },
        //获取弹幕
        getBarrage(e){
            var that=this,url='http://zhishi.wuliangye.com.cn:8866/wlyApp/listAskanswer.html',uuid=localStorage.getItem("uuid");
            var section=that.footerData.page;
            var that=this,data={uuid:'8d865efc-207e-4076-a81e-322817f1e40e'};
            // var looper_time=3*1000,looper;
            // var run_once=true;
            // do_barrager();
            // function do_barrager(){
            //   if(run_once){
            //       //如果是首次执行,则设置一个定时器,并且把首次执行置为false
            //       looper=setInterval(do_barrager,looper_time);                
            //       run_once=false;
            //   }
               
            // }
            if(uuid){    
            $.ajax({
                type:'POST',
                url:url,
                data:data,
                dataType:'json',
                success: function(res){
                    var itemArray=[],looper_time=1000;
                    if(res.res===1){
                        for(var i=0;i<res.rows.length;i++){
                            if(res.rows[i].section==section){
                                res.rows[i].info=res.rows[i].content;
                                res.rows[i].bottom=mathRandom($(window).height()/1.5,$(window).height()-50);
                                res.rows[i].close=false;
                                res.rows[i].href='javascript:;';
                                itemArray.push(res.rows[i]);
                            }
                        }
                        console.log(itemArray.length);
                        if(itemArray.length>0){
                            var looper_time=3*1000,run_once=true,total=itemArray.length,index=0;
                            barrager();
                            function barrager(){
                              if(run_once){
                                  //如果是首次执行,则设置一个定时器,并且把首次执行置为false
                                  that.looper=setInterval(barrager,looper_time);                
                                  run_once=false;
                              }
                              //发布一个弹幕
                              $('body').barrager(itemArray[index]);
                              //索引自增
                              index++;
                              //所有弹幕发布完毕，清除计时器。
                              if(index == total){
                                  clearInterval(that.looper);
                                  return false;
                              }
                            }
                        }else{
                            $.fn.barrager.removeAll();
                        }
                    }
                    
                }
            });
            function mathRandom(min, max) {
              return Math.floor(Math.random() * (max - min)) + min   
            }
            }
        }
    }
}
</script>